import type { SearchScenarioId } from 'owa-search-store';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * Action dispatched when suggestions should be set in the store. Consuming client
 * should set up an orchestrator to subscribe to it, which should read appropriate
 * values from the search store, fetch suggestions, and set them in the store.
 */
export interface GET_SUGGESTIONSActionMessage {
    scenarioId: SearchScenarioId;
}
export const getSuggestions: (scenarioId: SearchScenarioId) => GET_SUGGESTIONSActionMessage =
    action(
        'GET_SUGGESTIONS',
        (scenarioId: SearchScenarioId): GET_SUGGESTIONSActionMessage =>
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * Baseline. DO NOT COPY AND PASTE!
             *	> Argument at index 1 for addDatapointConfig must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            addDatapointConfig(
                'Search_SuggestionsE2E',
                undefined,
                {
                    unifiedTelemetry: {
                        eventName: 'PerformSearch',
                        data: {},
                    },
                },
                {
                    scenarioId,
                }
            )
    );
